import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'

type InitialTypes = {
  maritalstatus: any,
  checkssc: any,
  totalallowances: any,
  additionalamount: any,
  claimexempt: any,
  righttorefund: any,
  militaryservice: any,
  stateofdomicile: any
}

const ScInformationForm = ({ navigation, route }: any) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const { loading, postsconline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()


  const options1 = [
    {
      key: 1,
      value: 'Single'
    },
    { key: 2, value: 'Married' },
    { key: 3, value: 'Married, but withhold at higher Single rate' }
  ]

  const options2 = [
    { key: 1, value: 'For tax year 2025, I had a right to a refund of all South Carolina Income Tax withheld because I had no tax liability, and for tax year 2026, I expect a refund of all South Carolina Income Tax withheld because I expect to have no tax liability.' },
    { key: 2, value: 'For tax year 2026, I am a military servicemember or the spouse of a military servicemember and elect to use another state as my state of domicile. ' }
  ]
  const option3 = [
    { key: 1, value: 'Yes' },
    { key: 2, value: 'No' }
  ]
  const intialValues: InitialTypes = {
    maritalstatus: '',
    checkssc: null,
    totalallowances: '',
    additionalamount: '',
    claimexempt: '',
    righttorefund: null,
    militaryservice: null,
    stateofdomicile: ''
  }


  const w4schema = () => {
    const baseSchema = {
      maritalstatus: yup.string().required('Filing status is a required field'),
      claimexempt: yup
        .string()
        .nullable()
        .test(
          'is-exempt-or-empty',
          "Enter 'Exempt' or leave it empty",
          value => !value || /^exempt$/i.test(value)
        ),

      righttorefund: yup
        .string()
        .nullable()
        .when('claimexempt', {
          is: (val: string) => typeof val === 'string' && /^exempt$/i.test(val),
          then: schema => schema.required('Select any one option is a required field'),
          otherwise: schema => schema.nullable(),
        }),
      stateofdomicile: yup
        .string()
        .when('righttorefund', (righttorefund: any, schema) => {
          if (righttorefund == '1') {
            return schema.required('state of Domicile is a required field')
          }
          return schema.nullable()
        }),
      totalallowances: yup.string().required('Total no of allowances is a required field')
    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'SC Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {

            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: initializestore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'online' ? true : false,
              martialStatus: values?.maritalstatus,
              checkSsc: values?.checkssc === 0 ? values?.checkssc : null,
              totalAllowances: values?.totalallowances ? values?.totalallowances : null,
              additionalAmount: values?.additionalamount ? values?.additionalamount : null,
              claimExempt: values?.claimexempt,
              rightToRefund: values?.righttorefund === 0 ? values?.righttorefund : null,
              militaryService: values?.righttorefund === 1 ? 0 : null,
              stateOfDomicile: values?.stateofdomicile,
            }

            const response = await postsconline(data)
            if (response?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('ScInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,

                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <View>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.maritalstatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('maritalstatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.maritalstatus &&
                      props.errors.maritalstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.maritalstatus as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Is your last name different on your Social Security card?'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Is your last name different on your Social Security card?"
                      options={option3}
                      selectedOption={mapSelectValue(
                        option3,
                        props.values.checkssc
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('checkssc', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.checkssc && props.errors.checkssc && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.checkssc as string}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Total number of allowances*'}
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.totalallowances}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('totalallowances')(text)
                        }
                      }}
                    />
                    {props.touched.totalallowances &&
                      props.errors.totalallowances && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.totalallowances as string}
                        </Text>
                      )}
                  </View>
                </View>
                {props.values.claimexempt?.toLowerCase() !== 'exempt' && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '65%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Additional amount, if any, to withhold from each paycheck'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalamount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalamount')(text)
                          }
                        }}
                      />
                      {props.touched.additionalamount &&
                        props.errors.additionalamount && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.additionalamount as string}
                          </Text>
                        )}
                    </View>
                  </View>
                )}
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'If exempt, write exempt.'}
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.claimexempt}
                      onChangeText={(text) => {
                        props.handleChange('claimexempt')(text)
                        if (text?.toLowerCase() === 'exempt') {
                          props.setFieldValue('additionalamount', '')
                        }
                      }}
                    />
                    {props.touched.claimexempt && props.errors.claimexempt && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.claimexempt as string}
                      </Text>
                    )}
                  </View>
                </View>
                {props.values.claimexempt.toLowerCase() == 'exempt' ?
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '65%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'If you are claiming Exemption Select any one option *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="If you are claiming Exemption Select any one option *"
                        options={options2}
                        selectedOption={mapSelectValue(
                          options2,
                          props.values.righttorefund
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('righttorefund', option - 1)
                          props.setFieldValue('stateofdomicile', '')
                        }}
                        textColor="primary"
                      />
                      {props.touched.righttorefund &&
                        props.errors.righttorefund && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.righttorefund as string}
                          </Text>
                        )}
                    </View>
                  </View> :
                  <></>
                }

                {props?.values?.righttorefund == '1' ? (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '65%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'State of domicile *'}
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.stateofdomicile}
                        onChangeText={(text) => {
                          props.handleChange('stateofdomicile')(text)
                        }}
                      />
                      {props.touched.stateofdomicile &&
                        props.errors.stateofdomicile && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.stateofdomicile as string}
                          </Text>
                        )}
                    </View>
                  </View>
                ) :
                  <></>}
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </View>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default ScInformationForm
